import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import { getEventPage, updateEventPage } from "./actions";
import Page from "./Page";
import { getEvent } from "../../utils/token";

class EventPageCard extends Component {
  render() {
    return <Page {...this.props} />;
  }
}

const EventPageForm = Form.create({ name: "event-page-form" })(EventPageCard);

function mapStateToProps(state) {
  return {
    isLoading: state.eventPage.isLoading,
    eventPageData: state.eventPage.eventPageData,
    event: getEvent()
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onGetEventPage: (data) => dispatch(getEventPage(data)),
    onUpdateEventPage: (data) => dispatch(updateEventPage(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPageForm);
